import {SezioneAggiuntiva} from "./SezioneAggiuntiva";
import {IngredientePiatto} from "./IngredientePiatto";

export const PiattoConverter = {
    toFirestore(ingrediente: Piatto): firebase.firestore.DocumentData {
        return {};
    },
    fromFirestore(
        snapshot: firebase.firestore.QueryDocumentSnapshot,
        options: firebase.firestore.SnapshotOptions
    ): Piatto {
        const data = snapshot.data(options)!;
        let piatto = new Piatto();
        piatto.id = snapshot.id;
        piatto.plu = data.plu;
        piatto.nome = data.nome;
        piatto.nomeStampante = data.nome_stampante;
        piatto.descrizione = data.descrizione;
        piatto.prezzo = data.prezzo;
        piatto.sezioneMenu = data.sezione_menu;
        piatto.stampante = data.stampante;
        piatto.visibile = data.visibile;
        piatto.bloccaMenu = data.blocca_menu;
        piatto.sezioneAggiuntivaList = data.sezione_aggiuntiva_list;
        piatto.ingredienteList = data.ingrediente_list;
        return piatto;
    }
};

export class Piatto {
    id: string;
    plu: string;
    nome: string;
    nomeStampante: string;
    descrizione: string;
    prezzo: string;
    sezioneMenu: any;
    stampante: any;
    visibile: boolean;
    bloccaMenu: boolean;
    sezioneAggiuntivaList: SezioneAggiuntiva[];
    ingredienteList: IngredientePiatto[];

    constructor() {
        this.id = "";
        this.plu = "";
        this.nome = "";
        this.nomeStampante = "";
        this.descrizione = "";
        this.prezzo = "";
        this.sezioneMenu = "";
        this.stampante = null;
        this.visibile = true;
        this.bloccaMenu = false;
        this.sezioneAggiuntivaList = [];
        this.ingredienteList = [];
    }

    convertToFirestore(): any {
        return {
            nome: this.nome,
            plu: this.plu,
            nome_stampante: this.nomeStampante,
            descrizione: this.descrizione,
            prezzo: this.prezzo,
            sezione_menu: this.sezioneMenu,
            stampante: this.stampante,
            visibile: this.visibile,
            blocca_menu: this.bloccaMenu,
            ingrediente_list: [],
            sezione_aggiuntiva_list: []
        };
    }

    static async convertFromFirestore(id: string, data: any, dontPropagate?: boolean): Promise<Piatto> {
        let piatto = new Piatto();
        piatto.id = id;
        piatto.plu = data.plu;
        piatto.nome = data.nome;
        piatto.descrizione = data.descrizione;
        piatto.nomeStampante = data.nome_stampante;
        piatto.prezzo = data.prezzo;
        piatto.sezioneMenu = data.sezione_menu;
        piatto.stampante = data.stampante;
        piatto.visibile = data.visibile;
        piatto.bloccaMenu = data.blocca_menu;

        if(dontPropagate && dontPropagate === true) {
            return piatto;
        }

        for(let ingredientePiatto of data.ingrediente_list) {
            let ingredientePiattoConverted = await IngredientePiatto.convertFromFirestore(ingredientePiatto);
            piatto.ingredienteList.push(ingredientePiattoConverted);
        }
        
        for(let sezioneAggiuntiva of data.sezione_aggiuntiva_list) {
            let sezioneAggiuntivaGet = await sezioneAggiuntiva.get();
            let sezioneAggiuntivaConverted = await SezioneAggiuntiva.convertFromFirestore(await sezioneAggiuntivaGet.data());
            piatto.sezioneAggiuntivaList.push(sezioneAggiuntivaConverted);
        }

        return piatto;
    }
}